<!--
 * @Descripttion: 
 * @Version: 1.0.0
 * @Author: liyong
 * @Date: 2022-05-25 18:10:49
 * @LastEditors: liyong
 * @LastEditTime: 2022-06-20 14:10:31
 * @FilePath: /partner.chaoyongtuan.com/src/views/shopManage/orderDetails/list/components/updateOrderDialog/components/zsScaleDialog/index.vue
 * 
 * Copyright (c) 2022 by 央选/李勇, All Rights Reserved. 
-->
<template>
  <el-dialog :title="`修改${zsName}分成比`" :visible.sync="dialogVisible" width="520px" :before-close="handleClose">
    <div class="content">
      <Tip content="仅对筛选结果订单修改分成比例，不影响员工其它订单的分成比例"></Tip>
      <el-form class="mt-24" :model="form" :rules="rules" ref="ruleForm" label-width="100px" hide-required-asterisk>
        <el-form-item label-width="80px" prop="bd_partner_scale">
          <template v-slot:label>
            <span class="flex flex-align-center">
              <span>分成比</span>
              <explain class="fz-14 yx-color-info ml-4" :content="`系统根据所设分成比自动统计提成，提成=订单金额*服务费率*分成比，自动扣除技术服务费10%（快手侧扣除0），${zsName}侧将换算成提成比【服务费率*分成比】展示，当月提成按最新分成比统计`" />
            </span>
          </template>
          <el-input-number v-model="form.bd_partner_scale" controls-position="right" :min="0" :max="100" />
          <span class="yx-color-text-primary ml-8 mr-24">%</span>
        </el-form-item>
      </el-form>
    </div>
    <span slot="footer">
      <el-button @click="handleClose">取 消</el-button>
      <el-button type="primary" @click="submit">确 认</el-button>
    </span>
  </el-dialog>
</template>
<script>
import explain from '@/components/common/explain'
import { zsRoleType } from '@/utils/dataMap'

export default {
  components: {
    explain,
   
  },
  data() {
    return {
      form: {
        bd_partner_scale: ''
      },
      rules: {
        bd_partner_scale: { required: true, message: '请输入分成比', trigger: 'blur' },
      },
      dialogVisible: false
    }
  },
  computed: {
    zsName() {
      return zsRoleType.name
    }
  },
  methods: {
    show(bd_partner_scale = '') {
      this.form.bd_partner_scale = +bd_partner_scale || 0
      this.dialogVisible = true
    },
    handleClose() {
      this.form = {
        bd_partner_scale: ''
      }
      this.dialogVisible = false
    },
    submit() {
      this.$refs.ruleForm.validate(async valid => {
        if(!valid) return
        this.$emit('setScale', this.form)
        this.handleClose()
      })
    }
  }
}
</script>

<style lang='less' scoped></style>
